"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var TopList_styles_1 = require("./TopList.styles");
var filterNumOfChildren = function (num) { return function (_, index) { return index < num; }; };
var TopList = function (_a) {
    var children = _a.children, _b = _a.numberOfItems, numberOfItems = _b === void 0 ? 5 : _b, _c = _a.min, min = _c === void 0 ? 1 : _c, _d = _a.max, max = _d === void 0 ? 99 : _d, _e = _a.changeable, changeable = _e === void 0 ? false : _e, _f = _a.i18n, i18n = _f === void 0 ? {} : _f;
    var _g = i18n.beforeInput, beforeInput = _g === void 0 ? "Top" : _g, _h = i18n.afterInput, afterInput = _h === void 0 ? "Contents" : _h;
    var styles = (0, TopList_styles_1.useStyles)();
    var _j = (0, react_1.useState)("".concat(numberOfItems)), state = _j[0], setState = _j[1];
    var _k = (0, react_1.useState)(numberOfItems), num = _k[0], setNum = _k[1];
    var onChangeNum = function (value) {
        if (value == "") {
            setState("");
            return;
        }
        var number = parseInt(value);
        if (isNaN(number)) {
            return;
        }
        if (number > max || number < min) {
            return;
        }
        setState(value);
    };
    (0, react_1.useEffect)(function () {
        var number = parseInt(state);
        if (!isNaN(number)
            && number > 0
            && number >= min
            && number <= max) {
            setNum(number);
        }
    }, [state]);
    return (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.component }, { children: [(changeable) ?
                (0, jsx_runtime_1.jsxs)("h3", __assign({ className: styles.headline }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: styles.beforeInput }, { children: beforeInput })), (0, jsx_runtime_1.jsx)("input", { className: styles.input, type: "number", min: min, max: max, value: num, onChange: function (e) { return onChangeNum(e.target.value); } }), (0, jsx_runtime_1.jsx)("span", __assign({ className: styles.afterInput }, { children: afterInput }))] }))
                : null, (0, jsx_runtime_1.jsx)("ul", __assign({ className: styles.list }, { children: children === null || children === void 0 ? void 0 : children.filter(filterNumOfChildren((changeable) ? num : numberOfItems)) }))] }));
};
exports.default = TopList;
var Item = function (_a) {
    var text = _a.text, url = _a.url, description = _a.description;
    var firstLine = (url) ? (0, jsx_runtime_1.jsx)("a", __assign({ href: url }, { children: text })) : text;
    var secondLine = (description) ? (0, jsx_runtime_1.jsx)("div", { children: description }) : null;
    return (0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("div", { children: firstLine }), secondLine] });
};
exports.Item = Item;
